//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.1.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum TrainingAppointmentStatus {
    Planned = 0,
    Cancelled = 1,
    Closed = 2,
}

export interface TrainingSessionVm {
    id: number;
    order: number;
    title: string | null;
    startDate: Date;
    endDate: Date;
    trainingLocationId: number | null;
    trainingLocationName: string | null;
    isAttendanceRequired: boolean;
}

export interface TrainingSpeakerVm {
    id: number;
    portalUserId: string | null;
    displayName: string | null;
    externalName: string | null;
    externalEmail: string | null;
    comment: string | null;
}

export interface TrainingUserVm {
    id: string | null;
    fullName: string | null;
    userName: string | null;
}

export interface TrainingAppointmentVm {
    id: number;
    trainingEventId: number;
    name: string | null;
    status: TrainingAppointmentStatus;
    capacity: number | null;
    meetingLink: string | null;
    notes: string | null;
    startDate: Date;
    endDate: Date;
    registeredCount: number;
    waitlistCount: number;
    sessions: TrainingSessionVm[] | null;
    speakers: TrainingSpeakerVm[] | null;
    responsibles: TrainingUserVm[] | null;
}